import './App.css';
import ServiceTable from './components/ServiceTable';
import ServiceTableV2 from './components/ServiceTableV2';
import { useEffect, useState } from 'react';
import { sessionStatus, sessionIds } from './apis/session';

const SESSION_MESSAGES = {
  expired: 'Your session has expired. Please reopen the spending plan from Ankota.',
  invalid: 'This link is not valid. Please reopen the spending plan from Ankota.',
};

function App() {
  const [businessId, setBusinessId] = useState(null);
  const [patientId, setPatientId] = useState(null);
  const [hasParams, setHasParams] = useState(false);

  const isV1Route = window.location.pathname === '/v1';

  useEffect(() => {
    // Opened from Ankota with ?token=: patient and business come from the token, never the URL
    if (sessionIds) {
      setPatientId(sessionIds.patientId);
      setBusinessId(sessionIds.businessId);
      setHasParams(true);
      return;
    }
    if (sessionStatus !== 'none') return;

    // Extract parameters from URL and fall back to localStorage demo credentials
    const urlParams = new URLSearchParams(window.location.search);
    
    // Try all known casings/spellings used by .NET and other callers
    const urlPatientId = urlParams.get('patientId') || urlParams.get('PatientId') || urlParams.get('patiendId');
    let patientIdParam = urlPatientId;
    // If not provided in URL, try demo credentials stored after login/registration
    if (!patientIdParam) {
      try {
        const demo = JSON.parse(localStorage.getItem('demoUserCredentials') || '{}');
        if (demo?.patientId) patientIdParam = demo.patientId;
      } catch (e) { /* ignore */ }
    }
    const businessIdParam = urlParams.get('businessId') || urlParams.get('businessdId');
    const departmentIdParam = urlParams.get('departmentId') || urlParams.get('departmentid');

    setPatientId(patientIdParam);
    // Use V2 only when patientId is explicitly in the URL along with businessId or departmentId
    setHasParams(!!(urlPatientId && (businessIdParam || departmentIdParam)));

    // Prefer explicit businessId. If missing but departmentId exists, use departmentId as businessId.
    if (businessIdParam) {
      setBusinessId(businessIdParam);
      console.log('Extracted businessId:', businessIdParam);
    } else if (departmentIdParam) {
      setBusinessId(departmentIdParam);
      console.log('No businessId found; using departmentId as businessId:', departmentIdParam);
    } else {
      console.log('No businessId or departmentId found in URL, setting default to 1');
      setBusinessId('1');
    }

    console.log('Extracted patientId:', patientIdParam);

    // Fallback to default if not found - COMMENTED OUT to prevent guest mode issues
    // if (!patientIdParam) {
    //   setPatientId('0');
    // }
  }, []);

  if (SESSION_MESSAGES[sessionStatus]) {
    return (
      <div className="App flex items-center justify-center min-h-screen p-4">
        <p className="text-lg text-gray-700 text-center">{SESSION_MESSAGES[sessionStatus]}</p>
      </div>
    );
  }

  return (
    <div className="App">
      {isV1Route
        ? <ServiceTable businessId={businessId} patientId={patientId} />
        : hasParams
          ? <ServiceTableV2 businessId={businessId} patientId={patientId} />
          : <ServiceTable businessId={businessId} patientId={patientId} />
      }
    </div>
  );
}

export default App;
